export default __webpack_public_path__ + "static/media/logotipo.557c79b3.svg";